// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2HDbF","question":"Question_question__zjhLY","description":"Question_description__1iMI4"};